import { createElementBlock as c, openBlock as n, normalizeClass as a, createBlock as i, Fragment as g, createCommentVNode as l, toDisplayString as m } from "vue";
import o from "../icon-core/icon-core.vue.js";
/* empty css                       */
const r = {
  key: 1,
  "data-j-text": ""
}, f = /* @__PURE__ */ Object.assign({
  name: "DsTextIconElement"
}, {
  __name: "text-icon-element",
  props: {
    /**
     * left icon (optional)
     */
    iconLeft: {
      type: [Object, null],
      default: null,
      validator: (t) => ["name", "category"].every((e) => e in t)
    },
    /**
     * right icon (optional)
     */
    iconRight: {
      type: [Object, null],
      default: null,
      validator: (t) => ["name", "category"].every((e) => e in t)
    },
    /**
     * icon (optional)
     */
    icon: {
      type: [Object, null],
      default: null,
      validator: (t) => ["name", "category"].every((e) => e in t)
    },
    /**
     * text (optional)
     */
    text: {
      type: String,
      default: ""
    },
    /**
     * Adds 12px icon spacing (optional)
     */
    withSpacing: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    return (e, s) => (n(), c("div", {
      class: a(["ds-text-icon", { "ds-text-icon--icon-only": t.icon }]),
      "data-j-link-text": ""
    }, [
      t.icon ? (n(), i(o, {
        key: 0,
        category: t.icon.category,
        name: t.icon.name,
        class: a(t.icon.class),
        "data-j-link-icon-only": ""
      }, null, 8, ["category", "name", "class"])) : (n(), c(g, { key: 1 }, [
        t.iconLeft ? (n(), i(o, {
          key: 0,
          class: a(["ds-text-icon__icon ds-text-icon__icon--left", [t.withSpacing ? "ds-margin-right-12" : "ds-margin-right-8", t.iconLeft.class]]),
          category: t.iconLeft.category,
          name: t.iconLeft.name,
          "data-j-icon-left": ""
        }, null, 8, ["class", "category", "name"])) : l("", !0),
        t.text ? (n(), c("span", r, m(t.text), 1)) : l("", !0),
        t.iconRight ? (n(), i(o, {
          key: 2,
          class: a(["ds-text-icon__icon ds-text-icon__icon--right", [t.withSpacing ? "ds-margin-left-12" : "ds-margin-left-8", t.iconRight.class]]),
          category: t.iconRight.category,
          name: t.iconRight.name,
          "data-j-icon-right": ""
        }, null, 8, ["class", "category", "name"])) : l("", !0)
      ], 64))
    ], 2));
  }
});
export {
  f as default
};
